import React, {useContext} from 'react';
import {useFormContext} from 'react-hook-form';
import {FormFeedback} from 'reactstrap';
import RenderIf from '@src/components/RenderIf/RenderIf';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import Translate from '@src/components/Translate/Translate';
import app from '@src/helpers/app';
import classnames from '@src/helpers/classnames';

export default function FormErrorMessage(props: {
    fieldName: string,
    message?: string,
    forceDisplaying?: boolean,
}) {
    const context = useFormContext();
    const errors = context?.formState?.errors;
    const [design] = useContext(FormFieldDesignContext);
    const errorsBag = errors != null ?
            app('dot-accessor').get(errors, props.fieldName, null) :
            null;

    const message = props.message ?? (
            errorsBag != null && typeof errorsBag?.message === 'string' ? errorsBag?.message : null
    );

    return <RenderIf
            expression={message != null}
            render={() => {
                return <FormFeedback className={classnames(design.errorMessageContainerClass, {
                    'd-block': props.forceDisplaying,
                })}>
                    <Translate message={
                        message.replace(`The ${props.fieldName} field`, 'The field')
                    }/>
                </FormFeedback>;
            }}
    />;
}
